import { Component, OnInit, ViewChild, Inject, AfterViewInit } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material';
import { PermissionDialogComponent } from 'path-shared/components/permission-dialog/permission-dialog.component';
import { PaisosFilter } from '../../models/paisos-filter';
import { ComponentDialog } from 'path-shared/models/component-dialog.model';
import { Builder } from 'path-shared/models/builder';
import { PaisosTableComponent } from '../../components/paisos-table/paisos-table.component';
import { AuthorizationService } from 'path-shared/services/authorization/authorization-service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { NotificationService } from 'path-shared/services/notification/notification.service';
import { PaisosEditorComponent } from '../../components/paisos-editor/paisos-editor.component';
import { PaisosFilterComponent } from '../../components/paisos-filter/paisos-filter.component';

@Component({
  selector: 'app-paisos',
  templateUrl: './paisos.component.html',
  styleUrls: ['./paisos.component.scss']
})
export class PaisosComponent implements OnInit, AfterViewInit {

  permissionDialogRef: MatDialogRef<PermissionDialogComponent>;
  activeFilters: string[] = [];
  filterData: PaisosFilter;
  dataDialog: ComponentDialog = Builder.newComponentDialog();

  @ViewChild(PaisosTableComponent) paisosTable: PaisosTableComponent;

  constructor(
    private dialog: MatDialog,
    public auth: AuthorizationService,
    private i18n: I18n,
    private not: NotificationService,
    public thisDialogRef: MatDialogRef<PaisosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ComponentDialog,
    ) {
      this.filterData = new PaisosFilter('codi', 'desc');
      if (data !== undefined) {
        this.dataDialog = data;
      }
    }

  ngOnInit() {
    this.auth.UserCanSeePage(this.auth.Pages.TipusVehicles);
    this.paisosTable.itemClicked.subscribe(secure_id => {
      this.update(secure_id);
    });
    this.paisosTable.itemSelected.subscribe(codi => {
      this.thisDialogRef.close(codi);
    });
  }

  ngAfterViewInit() {
    if (!this.dataDialog.isDialog) {
      this.not.titleChange(this.i18n('Països'));
    }
  }

  edit() {
    const idSeleccionat: string = this.paisosTable.displayedItems['checkedItems'][0];
    this.update(idSeleccionat);
  }

  create() {
    this.update(null);
  }

  update(secure_id: string) {
    const data: ComponentDialog = Builder.newComponentDialog(true, false, secure_id);

    const ref = this.dialog.open(PaisosEditorComponent, {
      width: '70%',
      closeOnNavigation: false,
      autoFocus: true,
      data: data
    });

    ref.afterClosed().subscribe(updated => {
      if (updated) { this.paisosTable.load(); }
    });
  }

  refresh() {
    this.paisosTable.load();
  }

  onFilterClicked() {
    const ref = this.dialog.open(PaisosFilterComponent, {
      width: '50%',
      closeOnNavigation: false,
      autoFocus: true,
      data: {
        'filter': this.paisosTable.filter
      }
    });

    ref.componentInstance.notify.subscribe((filter: PaisosFilter) => {
      this.paisosTable.filter.set(filter);
      this.paisosTable.load();
    });
  }

  onRowSelected(somid) {
    this.update(somid);
  }

  generateExcel() {
    this.paisosTable.generateExcel();
  }

}
